export type NavItem = {
  key: string;
  label: string;
  to: string;
  icon: string;
  w: number;
  h: number;
  end?: boolean;
};

const asset = (name: string) => `/assets/nav/${name}.svg`;

export const navAsset = asset;

// 2x2 app switcher tiles at the top of the sidenav.
export const sixPack: NavItem[] = [
  { key: 'emails', label: 'Emails', to: '/', icon: 'mail', w: 16, h: 16, end: true },
  { key: 'forms', label: 'Forms', to: '/forms', icon: 'textalign', w: 15, h: 16 },
  { key: 'pages', label: 'Pages', to: '/pages', icon: 'website', w: 16, h: 14 },
  { key: 'social', label: 'Social', to: '/social', icon: 'social', w: 15, h: 15 },
];

// Primary navigation list below the app switcher.
export const navItems: NavItem[] = [
  { key: 'home', label: 'Home', to: '/home', icon: 'home', w: 15, h: 16 },
  { key: 'projects', label: 'Projects', to: '/projects', icon: 'project', w: 14, h: 14 },
  { key: 'planner', label: 'Planner', to: '/planner', icon: 'calendar', w: 15, h: 13 },
  { key: 'products', label: 'Products', to: '/products', icon: 'bag', w: 14, h: 16 },
  { key: 'workflows', label: 'Workflows', to: '/workflows', icon: 'workflow', w: 16, h: 16 },
  { key: 'analytics', label: 'Analytics', to: '/analytics', icon: 'analytics', w: 15, h: 16 },
  { key: 'audience', label: 'Audience', to: '/audience', icon: 'audience', w: 15, h: 15 },
];
